<template>
    <div>
        <el-button v-if="showButton" type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">查看点评</span>
        </el-button>
        <span v-if="!showButton" @click="getData" class="link-text">查看点评</span>
        <el-dialog
            title="用户点评"
            :visible.sync="showdialog"
            width="1000px"
            v-dialogDrag
            append-to-body>
            <div class="d-head" slot="title">
                <span class="title">用户点评</span>
                <div class="d-btn-group">
                    <el-input class="input-custom" v-model="f_houseid" placeholder="在这里输入房天下的楼盘编号" size="mini" clearable></el-input>
                    <el-button type="primary" size="mini" @click="pull">拉取点评</el-button>
                    <el-button type="success" size="mini" @click="save">上传点评</el-button>
                </div>
            </div>
            <div class="evaluate-box">
                <div class="ev-list" v-for="(item, index) in tableData" :key="index">
                    <div class="user flex-box" v-if="item.user">
                        <el-avatar icon="el-icon-user-solid" :size="40" shape="circle" :src="item.user.ltpic" fit="fill"></el-avatar>
                        <div class="name">{{item.user.name}}</div>
                        <div class="time">{{item.addDate}}</div>
                    </div>
                    <div class="content">
                        <p class="text">{{item.content}}</p>
                        <div class="pass-box" v-if="item.uid==''">
                            <!-- <div class="status">
                                <span>占个位置</span>
                            </div> -->
                            <div class="btn-box">
                                <el-button type="danger" size="mini" @click="delWuhanfang(item, index)" plain>删除</el-button>
                            </div>
                        </div>
                        <div class="pass-box" v-else>
                            <div class="status">
                                <span class="text-success" v-if="item.putaway">展示中</span>
                                <span class="text-danger" v-else>未展示</span>
                            </div>
                            <div class="btn-box">
                                <el-button type="danger" size="mini" plain v-if="item.putaway" @click="nopass(item)">
                                    <span class="el-icon-close"></span>
                                </el-button>
                                <el-button type="primary" size="mini" v-else @click="pass(item)">
                                    <span class="el-icon-check"></span>
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.discuss">
                        <div class="ev-list ev-append"  v-for="(it, id) in item.discuss" :key="id">
                            <div class="user flex-box" v-if="it.user">
                                <el-avatar icon="el-icon-user-solid" :size="40" shape="circle" :src="item.user.ltpic" fit="fill"></el-avatar>
                                <div class="name">{{it.user.name}}</div>
                                <div class="time">{{it.addDate}}</div>
                            </div>
                            <div class="content">
                                <p class="text">{{it.content}}</p>
                                <div class="pass-box">
                                    <div class="status">
                                        <span class="text-success" v-if="it.putaway">展示中</span>
                                        <span class="text-danger" v-else>未展示</span>
                                    </div>
                                    <div class="btn-box">
                                        <el-button type="danger" size="mini" plain v-if="it.putaway" @click="nopass(it)">
                                            <span class="el-icon-close"></span>
                                        </el-button>
                                        <el-button type="primary" size="mini" v-else @click="pass(it)">
                                            <span class="el-icon-check"></span>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination class="page-tion"
                @current-change="currentChange"
                layout="prev, pager, next"
                :page-size="pagesize"
                :total="total" background>
            </el-pagination>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'ProjectEvaluate',
    data() {
        return {
            showdialog: false,
            pageNo: 1,
            pagesize: 6,
            total: 0,
            tableData: [],
            f_houseid: '',
        }
    },
    props: {
        showButton: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: '',
        }
    },
    methods: {
        delWuhanfang(index) {
            this.tableData.splice(index, 1);
        },
        pull() {
            var params = {
                city: '武汉',
                dianpingNewcode: this.f_houseid,
                ifjiajing: 0,
                page: 1,
                tid: 1,
                pagesize: 20,
                starnum: 6,
                shtag: -1,
                rand: 0.162294400145216,
            }
            this.$api.wuhanfangajaxrequestdianpingList(params).then(
                data=>{
                    let {list} = data;
                    this.formateWuhanfangData(list);
                }
            )
        },

        formateWuhanfangData(lists) {
            if (typeof lists != 'object'){
                this.$message.error('请至少拉取一条数据')
                return;
            }
            var datas = [];
            for (var info of lists){
                var obj = {
                    addDate: info.create_time,
                    addtime: '',
                    click: 0,
                    content: info.content,
                    date: '',
                    did: '',
                    projectid: this.id,
                    putaway: false,
                    type: "project-remark",
                    uid: '',
                    user: {
                        ltpic: '',
                        name: '',
                    }
                };
                datas.push(obj)
            }
            this.tableData = datas;
        },
        save() {
            var params = {
                infos: JSON.stringify(this.tableData)
            }
            this.$api.addRobotComment(params).then(
                data=>{
                    this.$message.success('上传点评成功')
                    this.tableData = [];
                    this.getData();
                }
            )
        },
        getData() {
            if (this.showdialog == false) this.showdialog = true;
            var params = {
                id: this.id,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getProjectUserCommentListVsId(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        nopass(item) {
            var parmas = {
                id: item._id['$oid'],
                putaway: false,
            }
            this.$api.putawayProjectUserComment(parmas).then(
                data=>{
                    this.$message.success(data);
                    this.getData();
                }
            )
        },
        pass(item) {
            var parmas = {
                id: item._id['$oid'],
                putaway: true,
            }
            this.$api.putawayProjectUserComment(parmas).then(
                data=>{
                    this.$message.success(data);
                    this.getData();
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getData();
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.d-head{
    display: flex;
    .d-btn-group{
        flex: 1;
        text-align: right;
        padding-right: 40px;
        box-sizing: border-box;
        .input-custom{
            width: 300px;
            margin-right: 10px;
        }
    }
}
.evaluate-box{
    position: relative;
    overflow: hidden;
    .ev-list{
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
        .user{
            .name{
                margin-left: 10px;
                margin-right: 10px;
            }
            .time{
                color: #999;
                font-size: 13px;
            }
        }
        .content{
            padding-left: 50px;
            padding-right: 120px;
            box-sizing: border-box;
            box-sizing: border-box;
            position: relative;
            margin-top: -14px;
            margin-bottom: 14px;
            min-height: 34px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
            .text{
                font-size: 13px;
            }
            .pass-box{
                position: absolute;
                right: 0;
                top: -26px;
                .status{
                    text-align: center;
                }
                .btn-box{
                    margin-top: 6px;
                }
            }
        }
        .ev-append{
            padding-left: 50px;
            .content{
                padding-left: 40px;
                margin-top: -8px;
                margin-bottom: 4px;
                .pass-box{
                    top: -22px;
                }
            }
        }
    }
}
</style>